export default {
  container: {
    border: '1px solid #e5e5e5'
  },
  spinner: {
    fontSize: '20px'
  }
}
